import { render, staticRenderFns } from "./SemesterType.vue?vue&type=template&id=229f1151&"
import script from "./SemesterType.vue?vue&type=script&lang=js&"
export * from "./SemesterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports